/** Shared validation for every editable selection-group entry point. */
export function validateGroupText(value:string|undefined,label:string):void {
    if(value!==undefined && /[^\x20-\x7e\t\r\n]/.test(value))throw new Error(`${label}只能使用英文`);
}
